<template>
  <DsCheckbox v-model="proxy" />
</template>

<script lang="ts" setup>
import { DsCheckbox } from '@demvsystems/design-components';
import { computed } from 'vue';

interface Props {
  modelValue?: number;
}

const props = defineProps<Props>();

const emit = defineEmits(['update:modelValue']);

const proxy = computed({
  get: () => props.modelValue === 1,
  set: (val) => emit('update:modelValue', val ? 1 : 0),
});
</script>
